import { PaginatedData, PaginationParams } from 'models/PaginatedData';
import {
  DataRoomRFI,
  DataRoomRFIReport,
  FileTypeRFI,
} from '../../models/DataRoomRfi';
import httpClient from '../httpClient';

function createRfi(dataRoomId: string, values: Partial<DataRoomRFI>) {
  return httpClient.post<DataRoomRFI>(
    `data-room-rfis/data-rooms/${dataRoomId}`,
    values,
  );
}

function patchRfi(dataRoomRfiId: string, values: Partial<DataRoomRFI>) {
  return httpClient.patch<DataRoomRFI>(
    `data-room-rfis/${dataRoomRfiId}`,
    values,
  );
}

function getRfis(dataRoomId: string, params?: PaginationParams) {
  return httpClient.get<PaginatedData<DataRoomRFI>>(
    `data-room-rfis/data-rooms/${dataRoomId}`,
    {
      params,
    },
  );
}

function ignoreDocument(
  dataRoomRfiCategoryId: string,
  dataRoomRfiFileId: string,
) {
  return httpClient.post<FileTypeRFI>(
    `data-room-rfi-categories/${dataRoomRfiCategoryId}/data-room-rfi-files/${dataRoomRfiFileId}/ignore`,
  );
}

function deleteDocument(
  dataRoomRfiCategoryId: string,
  dataRoomRfiFileId: string,
) {
  return httpClient.post<FileTypeRFI>(
    `data-room-rfi-categories/${dataRoomRfiCategoryId}/data-room-rfi-files/${dataRoomRfiFileId}/delete-from-data-room`,
  );
}

function addDocumentToDR(
  dataRoomRfiCategoryId: string,
  dataRoomRfiFileId: string,
  parentId: string | null,
) {
  return httpClient.post<FileTypeRFI>(
    `data-room-rfi-categories/${dataRoomRfiCategoryId}/add-file-to-data-room`,
    {
      parentId,
      dataRoomRfiFileId,
    },
  );
}

function moveDocumentWithinDR(
  dataRoomRfiCategoryId: string,
  dataRoomRfiFileId: string,
  newParentId: string | null,
) {
  return httpClient.post<FileTypeRFI>(
    `data-room-rfi-categories/${dataRoomRfiCategoryId}/data-room-rfi-files/${dataRoomRfiFileId}/move`,
    {
      newParentId,
    },
  );
}

function bulkAddDRDocument(dataRoomRfiId: string, parentId: string | null) {
  return httpClient.post<FileTypeRFI[]>(
    `data-room-rfis/${dataRoomRfiId}/bulk-add-files-to-data-room`,
    {
      parentId,
    },
  );
}

function sendReminder(dataRoomRfiId: string, email: string) {
  return httpClient.post(`data-room-rfis/${dataRoomRfiId}/send-reminder`, {
    email,
  });
}

function closeRfi(dataRoomRfiId: string) {
  return httpClient.post<DataRoomRFI>(`data-room-rfis/${dataRoomRfiId}/close`);
}

function reopenRfi(dataRoomRfiId: string) {
  return httpClient.post<DataRoomRFI>(`data-room-rfis/${dataRoomRfiId}/reopen`);
}

function getRfiReports(dataRoomRfiId: string) {
  return httpClient.get<DataRoomRFIReport[]>(
    `data-room-rfis/${dataRoomRfiId}/reports`,
  );
}

function viewRfi(dataRoomRfiId: string) {
  return httpClient.post<DataRoomRFI>(`data-room-rfis/${dataRoomRfiId}/view`);
}

function changeUploadDestinationRfi(
  dataRoomRfiId: string,
  categories: Record<string, string>,
) {
  return httpClient.post<DataRoomRFI>(
    `data-room-rfis/${dataRoomRfiId}/change-upload-destination`,
    { categories },
  );
}

export default {
  createRfi,
  patchRfi,
  getRfis,
  ignoreDocument,
  deleteDocument,
  addDocumentToDR,
  moveDocumentWithinDR,
  bulkAddDRDocument,
  sendReminder,
  closeRfi,
  reopenRfi,
  getRfiReports,
  viewRfi,
  changeUploadDestinationRfi,
};
